"use client"

import successImage from "./email-success.png"
import classes from "./lifetimeWarrantySuccessPage.module.css"

const LifetimeWarrantySuccessPage = () => {
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <div className={classes.success}>
          <h2 className={classes.title}>
                        Success! Product Registered!
          </h2>
          <div className={classes.imageContainer}>
            <img
              classes={{
                root: classes.image 
              }}
              width={150}
              height={150}
              src={successImage.src}
            />
          </div>

          <p className={classes.subtitle}>
                        Your product is successfully registered!
          </p>
          <p className={classes.text}>
                        Check your email to find the confirmation email. Usually
                        it will arrive within 3 minutes.
          </p>
          <p className={classes.text}>
                        Please add{" "}
            <a
              className={classes.mailLink}
              href='mailto:info@hisea.com'
            >
                            info@hisea.com
            </a>{" "}
                        to your email contacts to avoid missing our important
                        emails.
          </p>
        </div>

        <div className={classes.block}>
          <div className={classes.blockImage}>
            <img
              src='https://www.hisea.com/media/wysiwyg/convenpage/hs-lifetime-warranty-success-pc-01.webp'
              alt=''
            />
          </div>
          <div className={classes.blockContentRight}>
            <h3 className={classes.blockTitle}>
                            Join our community
            </h3>
            <p className={classes.text}>
                            Join with other 1000+ members, always be the first
                            to know our giveaways, deals, and free product test
                            chances!
            </p>
            <a
              className={classes.link}
              target='_blank'
              rel='nofollow'
              href='https://www.facebook.com/groups/hisea'
            >
                            Join Now!
            </a>
          </div>
        </div>

        <div className={classes.block}>
          <div className={classes.blockContentLeft}>
            <h3 className={classes.blockTitle}>
                            Become a HISEA member!
            </h3>
            <p className={classes.text}>
                            Sign up on our website to become HISEA member and
                            earn reward points, birthday gifts and other
                            exclusive perks!
            </p>
            <a
              className={classes.link}
              target='_blank'
              rel='nofollow'
              href='https://hisea.com/advtr'
            >
                            Sign Up!
            </a>
          </div>
          <div className={classes.blockImage}>
            <img
              src='https://www.hisea.com/media/wysiwyg/convenpage/hs-lifetime-warranty-success-pc-03.webp'
              alt=''
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default LifetimeWarrantySuccessPage
